import { IJsonQuery } from '../../../packages/JsonQuery';
import { prepareMobileOffers } from 'shared/mappers/offers';
import {
  ISearchOffersForHouseCardMobileSiteOptions,
  TSearchOffersForHouseCardMobileSiteResponse_1,
  ISearchOffersForHouseCardMobileSiteResponse200,
  ISearchOffersForHouseCardMobileSiteResponse400,
  TSearchOffersForHouseCardMobileSiteResponseError,
  fetchSearchOffersForHouseCardMobileSite,
} from 'shared/repositories/search-engine/v1/search-offers-for-house-card-mobile-site';
import { EOffersStatus, IOffersMobile, IOffersState } from 'shared/types/offers';
import { assertResponseError } from 'shared/utils/errors';
import { request } from 'shared/utils/request';
import { TRequestParamsWithoutHttpApi } from 'shared/types/request';
import { IApplicationContext } from 'shared/types/applicationContext';
import { initialState } from 'shared/slices/offers/initialState';

type TParameters = TRequestParamsWithoutHttpApi<
  ISearchOffersForHouseCardMobileSiteOptions<
    ISearchOffersForHouseCardMobileSiteResponse200,
    ISearchOffersForHouseCardMobileSiteResponse400
  >
>;

export const fetchOffersMobile = (context: IApplicationContext, parameters: TParameters) =>
  request<
    IOffersState<IOffersMobile>,
    TParameters,
    TSearchOffersForHouseCardMobileSiteResponse_1,
    TSearchOffersForHouseCardMobileSiteResponseError
  >(context, {
    parameters,
    domain: 'fetchOffersMobile',
    fetchFunction: fetchSearchOffersForHouseCardMobileSite,
    prepareFunction: prepareMobileOffers,
    errorHandler: assertResponseError,
    defaultValue: {
      data: {
        jsonQuery: {
          _type: 'flatsale',
          geo: { type: 'geo', value: [{ type: 'house', id: parameters.parameters.houseId }] },
        } as IJsonQuery,
        offers: [],
        counters: initialState.data.counters,
      },
      status: EOffersStatus.Failed,
    },
  });
